// Shared shipping helpers used by the checkout UI.
// The backend (squareCartCheckout) has its own copy of this logic to prevent tampering.

export const WEIGHT_TO_GRAMS = { g: 1, kg: 1000, lb: 453.592, oz: 28.3495 };

export function weightToGrams(weight, unit) {
  if (weight == null || isNaN(Number(weight))) return 0;
  return Number(weight) * (WEIGHT_TO_GRAMS[unit || 'g'] || 1);
}

// Pick the matching active rate for a given total weight (grams).
// Bands are sorted by min_weight_g; first band whose range contains the weight wins.
// If no band contains the weight, fall back to the highest band (treated as "and above").
export function findShippingRate(rates, totalGrams) {
  const active = [...(rates || [])]
    .filter(r => r.active !== false)
    .sort((a, b) => (a.min_weight_g || 0) - (b.min_weight_g || 0));
  if (active.length === 0) return null;
  for (const r of active) {
    const min = r.min_weight_g || 0;
    const max = r.max_weight_g;
    if (totalGrams >= min && (max == null || max === '' || totalGrams <= max)) return r;
  }
  return active[active.length - 1];
}

// Sum total weight in grams for a list of cart product items, enriched with their product weight.
export function totalWeightGrams(items, weightById) {
  return items
    .filter(i => i.type === 'product')
    .reduce((sum, i) => {
      const w = weightById[i.product_id];
      return sum + weightToGrams(w?.weight, w?.weight_unit) * (i.quantity || 1);
    }, 0);
}